export const localStorageKeys = Object.freeze({
  wasHereBefore: 'sw-was-before',
  userAccountId: 'sw-user-account-id',
  userEmail: 'sw-user-email'
})



// WEBPACK FOOTER //
// ./src/js/const/common.const.js